<template>
  <LayoutPurchase>
    <template slot="purchaseOptions" v-if="persistPurchaseOptions">
      <div 
        class="subscription-container failable loadable" 
        :class="{ 
          failed: countries.error || purchaseOptions.error,
          loading: countries.loading || purchaseOptions.loading || fullLoading
        }"
      >
        <template v-if="!countries.error && !countries.loading">
          <SubscriptionForm
            v-if="!purchaseOptions.error && !purchaseOptions.loading"
            :selected-country="selectedCountry"
            :purchase-options="purchaseOptions.data"
            :show-currency="showCurrency"
            :view="view"
            @loadingChange="fullLoading = $event"
            @purchaseOptionSelectedChanged="purchaseOptionSelectedChangedHandler"
          />
        </template>
        <div class="failed-wrapper">
          <p class="error" v-if="countries.error">
            {{$t('error')}}
            <br>
            <button type="button" @click="loadCountries">
              {{$t('retry')}}
            </button>
          </p>
          <p class="error" v-if="purchaseOptions.error">
            {{$t('error')}}
            <br>
            <button type="button" @click="loadPurchaseOptions">
              {{$t('retry')}}
            </button>
          </p>
        </div>
        <div class="loader-wrapper">
          <Spinner/>
        </div>
      </div>
    </template>

    <template slot="disclaimers" class="disclaimers">
      <section class="disclaimers">
        <router-link :to="{name: 'home'}">
          <div class="logo"></div>
        </router-link>
        <div class="list" v-if="showCurrency">
          <p class="currency-disclaimer">
            {{$t('subscription.currency_disclaimer', {currency_description: showCurrency.description, currency_code: showCurrency.code, currency_symbol: showCurrency.symbol})}}
          </p>
          <PurchaseOptionLegals
            v-if="purchaseOptions.data[0]"
            :show-currency="showCurrency"
            :purchase-option="purchaseOptions.data[0]"
            :key="purchaseOptions.data[0].id"
            :include-option-description="true"
            :isOneTimePayment="true"
          />
        </div>
      </section>
    </template>
  </LayoutPurchase>
</template>


<script>
import LayoutPurchase from "../../layouts/LayoutPurchase";

import Spinner from "../../components/Spinner";
import SubscriptionForm from "../../components/Checkout/SubscriptionForm";
import PurchaseOptionLegals from "../../components/PurchaseOptionLegals";

import resources from "../../resources";

import { PurchaseView } from "../../types/enums";

export default {
  components: {
    LayoutPurchase,
    SubscriptionForm,
    PurchaseOptionLegals,
    Spinner,
  },
  props: {
    selectedCountry: {
      required: true,
      default: null,
    },
    showCurrency: {
      required: true,
      default: null,
    },
    countries: {
      required: true,
      type: Object,
      default: {
        data: [],
        loading: true,
        error: false,
      },
    },
  },
  data() {
    return {
      purchaseOptions: {
        data: [],
        loading: true,
        error: false,
      },
      purchaseOptionSelected: null,
      fullLoading: false,
      persistPurchaseOptions: false,
      view: PurchaseView.token,
    };
  },
  methods: {
    purchaseOptionSelectedChangedHandler(purchaseOptionSelected) {
      this.purchaseOptionSelected = purchaseOptionSelected;
    },
    loadPurchaseOptions() {
      this.purchaseOptions = {
        data: [],
        error: false,
        loading: true,
      };

      resources.purchaseOptions
        .index({
          country_id: this.selectedCountry ? this.selectedCountry.id : "INT",
          include: [
            "subscription_plan.payment_methods",
            "subscription_plan.onward_subscription_plan",
            "subscription_plan.one_click_pay_cards",
          ],
          tokens: 1,
        })
        .then((response) => {
          const data = this.sortOptionsByTokensAmount(response.data.data);
          this.purchaseOptions = {
            data,
            error: false,
            loading: false,
          };
        })
        .catch((err) => {
          this.purchaseOptions = {
            data: [],
            error: true,
            loading: false,
          };
        });
    },
    sortOptionsByTokensAmount(options) {
      return options.sort((a, b) => {
        return a.subscription_plan.data.tokens_quantity - b.subscription_plan.data.tokens_quantity;
      });
    },
    handlePersistPurchaseOptions() {
      if (this.persistPurchaseOptions) return;
      if (this.countries.loading || this.purchaseOptions.loading || this.fullLoading) return;

      this.persistPurchaseOptions = true;
    },
  },
  watch: {
    countries: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
    purchaseOptions: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
    fullLoading: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

.subscription-container {
  min-height: 400px;
}
.error {
  text-align: center;
}

section.disclaimers {
  display: block;
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;

  .logo {
    display: block;
    margin: auto;
    height: 50px;
    width: 100%;
    background-image: var(--img-logo);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-bottom: 20px;
  }

  .list {
    font-size: 1em;
    font-weight: bold;
  }
}
</style>
